import classNames from 'classnames'
import { FlagsProvider, useFeature } from 'flagged'

import { loginPathWithRedirect, newRegistryPath } from 'lib/urls'
import Image from 'components/image'
import { InfoButton, LinkButton } from 'components/buttons'
import { useScrollDirection } from 'lib/hooks'
import { useTracking, track, withContextualizedTracking } from 'lib/analytics'
import css from './styles.scss'

const MicroUtilityBar = () => {
  const c1UnifiedSearchPhase2Enabled = useFeature(
    'c1_unified_search_phase_2_enabled'
  )

  const tracker = useTracking()

  const scrollDirection = useScrollDirection()

  const handleLoginClick = () => {
    tracker.trackEvent({
      event: track.navbarClicked,
      eventLocation: track.EventLocation.MOBILE_WEB_TOP_UTILITY_BAR,
      eventCta: 'Login',
    })
    window.location.href = loginPathWithRedirect(window.location.pathname)
  }

  const handleSignUpClick = () => {
    tracker.trackEvent({
      event: track.navbarClicked,
      eventLocation: track.EventLocation.MOBILE_WEB_TOP_UTILITY_BAR,
      eventCta: 'Sign Up',
    })
    window.location.href = `${newRegistryPath}?loc=${track.EventLocation.MOBILE_WEB_TOP_UTILITY_BAR}`
  }

  const rootClassName = classNames(css.root, {
    [css.pinned]: scrollDirection === 'down',
    [css.unifiedSearchEnabled]: c1UnifiedSearchPhase2Enabled,
  })

  return (
    <div className={rootClassName}>
      <div className={css.left} />
      <div className={css.right}>
        <LinkButton className={css.link} onClick={handleLoginClick}>
          Log in
        </LinkButton>
        <InfoButton
          pill
          className={css.signUpButton}
          onClick={handleSignUpClick}
        >
          Sign up{' '}
          <Image
            role="presentation"
            src="//images.babylist.com/image/upload/v1683907821/heart_c2cuig.svg"
          />
        </InfoButton>
      </div>
    </div>
  )
}

const FeatureFlagProvidedMicroUtilityBar = (props: any) => (
  <FlagsProvider features={props.featureFlags}>
    <MicroUtilityBar {...props} />
  </FlagsProvider>
)

export default withContextualizedTracking({
  eventLocation: track.EventLocation.MOBILE_WEB_TOP_UTILITY_BAR,
})(FeatureFlagProvidedMicroUtilityBar)
